// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nform[data-v-2dbf3abf] {\n\tmargin-bottom: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
